import type { WreathDesignId } from '@forbiz/contracts'

import { WREATH_DESIGNS } from '../lib/digitalWreath.js'
import s from './WreathDesign.module.css'

/**
 * 디지털 화환 공용 그림 조각. 설정 페이지(DigitalWreathPage)와 주문서가 같은 걸 그려
 * "고른 디자인 = 올라가는 디자인"이 어긋나지 않게 한다.
 */

/** 국화 한 송이 — 근조 엠블럼. currentColor를 따른다. */
export function Chrysanthemum({ className }: { className?: string | undefined }) {
  const petals = []
  for (let i = 0; i < 12; i++) {
    petals.push(<ellipse key={`o${i}`} cx="50" cy="28" rx="5" ry="15" transform={`rotate(${i * 30} 50 50)`} />)
  }
  for (let i = 0; i < 8; i++) {
    petals.push(
      <ellipse key={`i${i}`} cx="50" cy="34" rx="4" ry="11" opacity="0.8" transform={`rotate(${i * 45 + 22} 50 50)`} />,
    )
  }
  return (
    <svg className={className} viewBox="0 0 100 100" aria-hidden="true">
      <g fill="currentColor">{petals}</g>
      <circle cx="50" cy="50" r="6" fill="currentColor" opacity="0.55" />
    </svg>
  )
}

/** 디자인 고르기 — 가로 스크롤 썸네일 행(라디오 그룹). */
export function WreathDesignPicker({
  value,
  onChange,
  disabled,
}: {
  value: WreathDesignId
  onChange: (id: WreathDesignId) => void
  disabled?: boolean | undefined
}) {
  return (
    <div className={s.row} role="radiogroup" aria-label="디지털 화환 디자인">
      {WREATH_DESIGNS.map((d) => {
        const bar = `linear-gradient(180deg, ${d.bar[0]} 0%, ${d.bar[1]} 100%)`
        const on = value === d.id
        return (
          <button
            key={d.id}
            type="button"
            role="radio"
            aria-checked={on}
            className={on ? `${s.pick} ${s.pickOn}` : s.pick}
            onClick={() => onChange(d.id)}
            disabled={disabled}
          >
            <span className={s.thumb} aria-hidden="true">
              <span className={s.thumbBar} style={{ background: bar }} />
              <span className={s.thumbBody} style={{ background: d.circleBg, color: d.flower }}>
                <Chrysanthemum className={s.thumbFlower} />
              </span>
              <span className={s.thumbBar} style={{ background: bar }} />
              {on ? <span className={s.check}>✓</span> : null}
            </span>
            <span className={s.name}>{d.name}</span>
          </button>
        )
      })}
    </div>
  )
}
